module.exports = __webpack_public_path__ + "img/participant-list-desktop-en.20061a14.jpg";